import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { PrismaXsConstant } from '../../../shared/models/prisma-xs.constant';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-bom-discount',
    templateUrl: './bom-discount.component.html',
    styleUrls: ['./bom-discount.component.scss'],
    standalone: false
})
export class BomDiscountComponent {
  @Input() totalPrice: number;
  @Input() discountOnPrice = 0;
  @Input() discountEnabled = false;
  @Output() discount = new EventEmitter<number>();
  @Output() enableDiscount = new EventEmitter<boolean>();

  VAT = PrismaXsConstant.VAT;
  CURRENCY = PrismaXsConstant.DEFAULT_CURRENCY;

  setDiscountOn(discountChecked: boolean) {
    this.enableDiscount.next(discountChecked);
  }

  changeDiscount(discount: string) {
    this.discount.emit(parseFloat(discount));
  }
}
